import { useRef } from 'react';

import { App } from 'antd';

import Layout from '../../../components/Layout/Layout';
import CompanyFilters from './Components/CompanyFilters';
import CompanyModals from './Components/CompanyModals';
import CompanyTable from './Components/CompanyTable';
import { useCompanyMetadata } from './hooks/useCompanyMetadata';
import { useCompanyModals } from './hooks/useCompanyModals';
import { useCompanyTable } from './hooks/useCompanyTable';
import { CompanyModalHandlers } from './types';

import './Companies.scss';

function Companies() {
  const { message } = App.useApp();

  const modalHandlersRef = useRef<CompanyModalHandlers>({
    openDetailModal: () => {
      /* placeholder for modal handler */
    },
    openMenuDetailModal: () => {
      /* placeholder for modal handler */
    },
    openChangePasswordModal: () => {
      /* placeholder for modal handler */
    },
  });

  const metadata = useCompanyMetadata({ message });

  const table = useCompanyTable({
    message,
    setTableLoading: metadata.setTableLoading,
    modalHandlers: modalHandlersRef.current,
  });

  const modals = useCompanyModals({
    message,
    fetchDataFromServer: table.fetchDataFromServer,
    setTableLoading: metadata.setTableLoading,
  });

  // Sincronizar los handlers reales tras el render inicial
  modalHandlersRef.current = {
    openDetailModal: modals.openDetailModal,
    openMenuDetailModal: modals.openMenuDetailModal,
    openChangePasswordModal: modals.openChangePasswordModal,
  };

  return (
    <Layout title={''}>
      <CompanyFilters
        tableLoading={metadata.tableLoading}
        onSearch={table.onSearch}
        onCreateCompany={modals.openNewCompanyModal}
      />
      <CompanyTable
        table={table}
        countries={metadata.countries}
        tableLoading={metadata.tableLoading}
      />
      <CompanyModals modals={modals} countries={metadata.countries} />
    </Layout>
  );
}

export default Companies;
